import * as o from "react";
function n() {
  const t = o.createContext(void 0);
  function r() {
    const e = o.useContext(t);
    if (!e) throw new Error("useContext must be inside a Provider with a value");
    return e;
  }
  return [r, t.Provider];
}
export {
  n as createContext
};
//# sourceMappingURL=help-center-articles-search6.js.map
